import api from '../../../../App/socket';

export const getCapValuation = (derivative_id, full_year, year, year_code, mileage, bike_lead_id) => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetCapData',
    options: {
        method: 'getAndSaveLookupUsedVehicleValueByCap',
        params: {
            derivative_id, full_year, year, year_code, mileage, bike_lead_id,
        },
    },
}).then((response) => response).catch((error) => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_cap_valuation_request.js